import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@mui/material';
import Pagination from "react-js-pagination";
import useWindowDimensions from '../utils/useWindowDimensions';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import mainPath from '../utils/path';
import axios from 'axios';
import { setPageAll } from '../redux/pageSlice';

const useStyles = makeStyles((theme)=>({
    ShopList: props => ({
        maxWidth: props.maxWidth,
        margin:'0 auto', 
        padding:'10px 0px 0px 0px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',

        fontFamily:[
            'Noto Sans KR'
        ],
    }),
    ShopItemBox: props => ({
        maxWidth: props.maxWidth,
        display: 'grid',
        gridTemplateColumns: `repeat(${props.colums}, 1fr)`,
        gridColumnGap: props.columGap,
        gridRowGap: props.rowGap,
        placeItems: 'center',
        [theme.breakpoints.down('sm')]: { //600px
        gridTemplateColumns: `repeat(${props.columsMobile}, 1fr)`,
        gridColumnGap: props.columGapMobile,
        gridRowGap: props.rowGap,
        },

        [theme.breakpoints.down(1025)]: {
            placeItems: 'normal start',
        }
    }),
    innerClass: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '75px',
        listStyle: 'none',
        padding: 0,
    },
    itemClass: {
        display: 'inline-block',
        width: '36px',
        height: '30px',
        border: '1px solid #DDDDDD',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '1rem',
    },
    itemClassFirst: {
    },
    itemClassLast: {
    },
    linkClass: {
        fontSize: '0.8rem',
    },
    activeClass: {
        backgroundColor: '#007235'
    },
    activeLinkClass: {
        color: 'white',
    },
    noItmebox: props => ({
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        padding: 100,
        minHeight: 1000,
        borderBottom: '1px solid gray',
    }),

}));




const ShopItemListType1 = ({
        data,
        maxWidth =1200, 
        imageWidth=270, 
        imageHeight=270, 
        imageWidthMobile=160, 
        imageHeightMobile=160, 
        colums=4, 
        lines=2, 
        columsMobile=2, 
        linesMobile=4,
        columGap=20,
        rowGap=20,
        columGapMobile=10,
        rowGapMobile=10,
        pages=5,
        pagesMobile= 5
    }) => {
    const dispatch = useDispatch()
    const pageAll = useSelector(state => state.page.pageAll);
    const [page, setPage] = useState(1);
    const [itemList, setItemList] = useState([])
    const { width } = useWindowDimensions();
    const theme = useTheme();
    let editTheme = {...theme, maxWidth, colums, columsMobile, columGap, rowGap, columGapMobile, rowGapMobile}
    const classes = useStyles(editTheme);

    useEffect(() => {
        if (data.length > 0) {
            if (width < 600) {
                //모바일 
                setItemList(data.slice(((columsMobile * linesMobile) * page ) - (columsMobile * linesMobile), ((columsMobile * linesMobile) * page )))
            } else {
                // 웹
                setItemList(data.slice(((colums * lines) * page ) - (colums * lines), ((colums * lines) * page )))
            }
        }
    }, [width, page, data])

    const setPageConfig = () => {
        dispatch(setPageAll(page))
    }

    useEffect(() => {
        
        setPageConfig()
    } , [page])

    useEffect(() => {

        setPage(pageAll)
        
    }, [])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [page])

    
    const itemListQty = useMemo(() => {
        if (width < 600) return linesMobile * columsMobile;
        return lines * colums;
    }, [width])

    const pageNums = useMemo(() => {
        if (width < 600) return pagesMobile;
        return pages;
    }, [width])

    const handlePageChange = useCallback((page) => {
        setPage(page);
    }, [page]);

    const noItem = useCallback(() => (<div className={classes.noItmebox}>
        <p>상품이 없습니다</p>
        </div>), [])



    return (
    <div className={classes.ShopList}>
        {data.length === 0 ? noItem() :
                                    <div className={classes.ShopItemBox}>
                                        {itemList && itemList.map((item) => <ShopItem 
                                                                key={item['it_id']}
                                                                itId={item['it_id']}
                                                                itName={item['it_name']}
                                                                itPrice={item['it_price']}
                                                                itImg={item['it_img1']}
                                                                itType1={item['it_type1']}  //히트상품
                                                                itType2={item['it_type2']}  //추천상품
                                                                itType3={item['it_type3']}  //신규상품
                                                                itType4={item['it_type4']}  //인기상품
                                                                itType5={item['it_type5']}  //할인상품
                                                                itStockQty={item['it_stock_qty']}
                                                                imageWidth={imageWidth} 
                                                                imageHeight={imageHeight} 
                                                                imageWidthMobile={imageWidthMobile}
                                                                imageHeightMobile={imageHeightMobile}
                                                            />)}
                                    </div>
        }

        <Pagination
            activePage={page}
            itemsCountPerPage={itemListQty}
            totalItemsCount={data.length}
            pageRangeDisplayed={pageNums}
            prevPageText={"‹"}
            nextPageText={"›"}
            onChange={handlePageChange}
            className={classes.navi}
            innerClass={classes.innerClass}    //안에?
            itemClass={classes.itemClass}      //아이템들?
            itemClassFirst={classes.itemClassFirst}    //first?
            itemClassLast={classes.itemClassLast}     // last
            linkClass={classes.linkClass}        // 아이템 링크
            activeClass={classes.activeClass}        // 현재페이지
            activeLinkClass={classes.activeLinkClass}     // 현제페이지 링크
        />
    </div>
    )
}


const useItemStyles = makeStyles((theme)=>({
    ItemBox: {
        minHeight: 200,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        cursor: 'pointer',
    },
    ItemImg: props =>({
        width: props.imageWidth,
        height: props.imageHeight,
        position: 'relative',

        [theme.breakpoints.down(1025)]: {
            width: props.imageWidthMobile,
            height: props.imageHeightMobile,
        },
        [theme.breakpoints.down(281)]: {
            width: '130px',
            height: '130px',
        }
    }),
    ItemTextBox: props => ({
        width: props.imageWidth,

        [theme.breakpoints.down(1025)]: {
            width: props.imageWidthMobile,
        },

        [theme.breakpoints.down(281)]: {
            width: '130px',
            height: '130px',
        }
    }),
    ItemTypeBox: {
        display: 'flex',
    },
    ItemTextBoxP:{
        borderBottom:'1px solid #ccc',
        padding:'5px 0',
        color:'#232323',
        letterSpacing: '-0.9px',
    },
    ItemTextBoxH1:{
        color:'#666666',
        fontSize:'14px',
        letterSpacing: '-0.7px',
        borderBottom:'1px solid #ccc',
        padding:'2px 0',
    },
    floatingCart: {
        position: 'absolute',
        bottom: '2%',
        right: '2%',
        
        '&:hover':{
            transform: 'scale(1.02)'
        },
        [theme.breakpoints.down(1025)]: {
            display: 'none'
        },
    },
    ItemImgin: {
        width: '100%', 
        height: '100%', 
        borderRadius: 5,
        transition: 'transform .5s',
        '&:hover':{
            transform: 'scale(1.02)'
        },
    }

}));

const ShopItem = ({
            itId, 
            itName, 
            itPrice, 
            itImg,
            itType1,
            itType2,
            itType3,
            itType4,
            itType5, 
            itStockQty,
            imageWidth, 
            imageHeight, 
            imageWidthMobile, 
            imageHeightMobile}) => {
    let navigate = useNavigate();
    const theme = useTheme();
    let editTheme = {...theme, imageWidth, imageHeight, imageWidthMobile, imageHeightMobile}
    const classes = useItemStyles(editTheme);
    const login = useSelector(state => state.user.login);
    const mbId = useSelector(state => state.user.userInfo['mb_id']);

    const goToItemDetail = () => {
        if(!login) return alert('로그인후 이용 가능합니다.')
 
        navigate("/ShopMain/ShopItem", {
            state: { itId: itId }
          });
    }

    const addCart = async() => {
        if (!login) return alert('로그인후 이용 해주세요.')
        if (itStockQty === 0) return alert('품절된 상품 입니다.')
    
        let ip = ''
        let cartItems =[]
    
        try {
          const res = await axios.post('/api/shop/getCart/', {mb_id: mbId})
          if(res.data.success === false) {
            alert('실패하였습니다.')
            return
          }
          
          res.data.result.forEach(itm => {
            cartItems.push(itm.it_id)
          })
    
      
        } catch (e) {
          console.log(e)
        }
    
        if (cartItems.includes(itId)) return alert('이미 카트에 존재하는 상품입니다.')
    
    
        // try {
        //   const response = await axios.get('https://api.ipify.org?format=json');
        //   ip = response.data.ip;
        // } catch (error) {
        //   console.error(error);
        //   return
        // }
    
    
        try {
            const res = await axios.post(
              '/api/shop/addCart/', 
              {
                mb_id: mbId,
                it_id: itId,
                ct_qty: 1,
                ct_ip: ip,
              }
            )
    
            if(res.data.success === false) {
                alert('실패하였습니다.')
                return
            }
    
            alert('카트에 추가 되었습니다.')
    
          } catch (e) {
            console.log(e)
          }
      }

    return (
        <div className={classes.ItemBox}>
            <div className={classes.ItemImg}>
                <img
                    className={classes.ItemImgin}
                    src={`${mainPath}/media/data/item/${itImg}`}
                    onClick={goToItemDetail} 
                />
                    <div 
                        className={classes.floatingCart}
                        onClick={addCart}
                    >
                        <img src='/images/cart_btn.png' />
                    </div>
            </div>
            {/* <div className={classes.ItemTypeBox}>
                {itType1 === 1 && (<p>히트상품</p>)}
                {itType2 === 1 && (<p>추천상품</p>)}
                {itType3 === 1 && (<p>신규상품</p>)}
                {itType4 === 1 && (<p>인기상품</p>)}
                {itType5 === 1 && (<p>할인상품</p>)}
            </div> */}
            <div 
                className={classes.ItemTextBox}
                onClick={goToItemDetail} 
            >
                <p className={classes.ItemTextBoxP}>{itName}</p>
                <h1 className={classes.ItemTextBoxH1}>{login ? `${itPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} 원`: '회원 공개'}</h1>
            </div>
        </div>
    )
}


ShopItemListType1.propTypes = {
    /**
     * 게시판 기본 컴포넌트
     */
    data : PropTypes.array.isRequired,
    /**
     * @description
     * 쇼핑몰 들어갈 Objsect List 넣어주셈
     */
    maxWidth : PropTypes.number,
    /**
     * @description
     * 쇼핑몰 박스 전체 넓이 
     * default = 1000
     */
    imageWidth: PropTypes.number,
        /**
     * @description
    *  아이템 이미지별 넓이  
    *  default = 250
    */
    imageHeight: PropTypes.number,
        /**
     * @description
    *  아이템별 이미지 높이
    *  default = 300
    */
    imageWidthMobile: PropTypes.number,
        /**
     * @description
    *  아이템 이미지별 넓이 (모바일)
    *  default = 150
    */
    imageHeightMobile: PropTypes.number,
        /**
     * @description
    *  아이템별 이미지 높이 (모바일)
    *  default = 180
    */
    colums: PropTypes.number,
        /**
     * @description
    *  아이템 가로 갯수 
    *  default = 4
    */
    lines: PropTypes.number,
        /**
     * @description
    *  아이템 세로갯수
    *  default = 4
    */
    columsMobile: PropTypes.number,
        /**
     * @description
    *  아이템 가로 갯수 (모바일)
    *  default = 2
    */
    linesMobile: PropTypes.number,
        /**
     * @description
    *  아이템 세로갯수
    *  default = 2
    */
    columGap: PropTypes.number,
        /**
     * @description
    *  컬럼 사이 간격 
    *  default = 20
    */
    rowGap: PropTypes.number,
        /**
     * @description
    *  로우 사이 간격 
    *  default = 20
    */
    columGapMobile: PropTypes.number,
        /**
     * @description
    *  컬럼 사이 간격  (모바일)
    *  default = 10
    */
    rowGapMobile: PropTypes.number,
        /**
     * @description
    *  로우 사이 간격 (모바일) 
    *  default = 10
    */
    page: PropTypes.number,
    /**
      * @description
     *  게시판 하단 보여줄 페이징수 설정 
     *  default = 10
     */
    pageMobile: PropTypes.number,
    /**
     * @description
     *  게시판 하단 보여줄 페이징수 설정 (모바일) 
     *  default = 5
     */

};


export default ShopItemListType1;
